import { useEffect, useRef, useState} from "react";
import {getPaymentStatus} from "../api/payment.ts";

const usePaymentListener = (requestId: string)=>{
    const interval = 2 * 1000;
    const timeoutRef = useRef(null);
    const [response, setResponse] = useState<any>(null);

    const listenToRequest = async () => {
       try {
           const response: any =  await getPaymentStatus(requestId);
           setResponse(response);
       } catch (e: any) {
           setResponse(e?.response?.data);
           if(e?.response?.data?.status === 8) stopBackgroundCalls();
       }
    };

    const scheduleNextCall = () => {
        // @ts-ignore
        timeoutRef.current = setTimeout(() => {
            listenToRequest();
            scheduleNextCall();
        }, interval);
        //}, intervalHours * 60 * 60 * 1000); // Conversion en millisecondes
    };

    const startBackgroundCalls = () => {
        listenToRequest();
        scheduleNextCall();
    };

    const stopBackgroundCalls = () => {
        if (timeoutRef.current) {
            clearTimeout(timeoutRef.current);
        }
    };

    // Nettoyage lors du démontage du composant
    useEffect(() => {
        return () => {
            if (timeoutRef.current) {
                clearTimeout(timeoutRef.current);
            }
        };
    }, []);


    return {
        response,
        startBackgroundCalls,
        stopBackgroundCalls,
    }
}

export default usePaymentListener;
